import { useLayoutEffect, useRef } from 'react';

// Keeps a list screen's scroll position across a trip to a payment detail hosted by the
// same component (no router). The host calls the returned remember() just before
// opening; the detail is shown from its top, and on return the list — still in the
// host's state, so committed in the same render — is put back where it was. A layout
// effect runs after the list is in the DOM and before paint, so there is no jump.
export function useListScroll(openId: string | null): () => void {
  const savedY = useRef<number | null>(null);

  useLayoutEffect(() => {
    if (openId !== null) {
      window.scrollTo(0, 0);
    } else if (savedY.current !== null) {
      window.scrollTo(0, savedY.current);
      savedY.current = null;
    }
  }, [openId]);

  return () => {
    savedY.current = window.scrollY;
  };
}
